import { doRequest, REQUEST_METHODS } from './myBase'
import { useStripeStore } from '@/stores/stripe'
import { useOrderStore, PAYMENT_METHOD } from '@/stores/order'
import { buildCustomerData } from './orders'
import { getError } from '@/utils/errors'
import { useHotjarStore } from '@/stores/hotjar'

const PaymentIntentSuccessStatuses = {
  SUCCEEDED: 'succeeded',
  REQUIRES_CAPTURE: 'requires_capture'
}

const requestPaymentIntentClientSecret = async () => {
  const orderStore = useOrderStore()
  const hotjarStore = useHotjarStore()

  const result = (await doRequest(REQUEST_METHODS.POST, '/api/payments/payment_intent', {
    wallet: orderStore.paymentMethod || PAYMENT_METHOD.OTHER_PAYMENT,
    items: orderStore.items,
    hotjar_session_id: hotjarStore.sessionId,
    ...buildCustomerData()
  })) as PaymentIntentResponse

  if (result.error) {
    return { error: getError(result) }
  } else {
    return { client_secret: result.client_secret }
  }
}

export const getPaymentIntentSecretForCof = async (
  card: string,
  orderData: any
): Promise<PaymentIntentCofResponse> => {
  return await doRequest(REQUEST_METHODS.POST, '/api/customers/payments/payment_intent_cof', {
    card,
    ...orderData
  })
}

export const requestPaymentIntent = async (paymentMethod: any) => {
  const stripeStore = useStripeStore()
  const responseClientSecret = await requestPaymentIntentClientSecret()
  const genericError = 'Unable to complete the payment.'

  if (responseClientSecret.client_secret) {
    const { error, paymentIntent } = await stripeStore.stripe.confirmCardPayment(
      responseClientSecret.client_secret,
      { payment_method: paymentMethod },
      { handleActions: false }
    )

    if (
      paymentIntent?.status === PaymentIntentSuccessStatuses.SUCCEEDED ||
      paymentIntent?.status === PaymentIntentSuccessStatuses.REQUIRES_CAPTURE
    ) {
      return { paymentIntentId: paymentIntent.id }
    } else {
      return { error: error?.message || genericError }
    }
  } else {
    return { error: getError(responseClientSecret, genericError) }
  }
}

export default {
  requestPaymentIntent,
  getPaymentIntentSecretForCof
}
